import React from "react";

const Missions = ({ isOpen_, mission }) => {
  return (
    <div className="flex flex-col w-full gap-3 text-[14px] text-black mb-10">
      <hr className="bg-black w-full" />
      {isOpen_ && (
        <>
          <div className="text-black text-[16px] font-semibold">
            Finish your mission to get a surprise gift
          </div>
          <div>Mission checklist</div>
        </>
      )}
      <div
        className={`flex flex-row gap-2 text-[14px] font-medium ${
          mission["create_card"] ? "text-primary" : "text-black"
        } items-center`}
      >
        <div className="flex flex-col w-fit relative px-3">
          <svg
            width="33"
            height="34"
            viewBox="0 0 33 34"
            xmlns="http://www.w3.org/2000/svg"
            className={`${
              mission["create_card"] ? "fill-primary" : "fill-transparent"
            }`}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.2957 2.02214C17.6811 0.659285 15.319 0.659287 13.7043 2.02214L12.2338 3.26332C11.5475 3.84257 10.6983 4.19437 9.80337 4.27005L7.88592 4.4322C5.78049 4.61025 4.11025 6.28049 3.9322 8.38592L3.77005 10.3034C3.69437 11.1983 3.34257 12.0475 2.76332 12.7338L1.52214 14.2043C0.159285 15.819 0.159287 18.1811 1.52214 19.7957L2.76332 21.2662C3.34257 21.9525 3.69437 22.8018 3.77005 23.6967L3.9322 25.6142C4.11025 27.7196 5.78049 29.3899 7.88592 29.5678L9.80337 29.7299C10.6983 29.8058 11.5475 30.1575 12.2338 30.7368L13.7043 31.978C15.319 33.3407 17.6811 33.3407 19.2957 31.978L20.7662 30.7368C21.4525 30.1575 22.3018 29.8058 23.1967 29.7299L25.1142 29.5678C27.2196 29.3899 28.8899 27.7196 29.0678 25.6142L29.2299 23.6967C29.3058 22.8018 29.6575 21.9525 30.2368 21.2662L31.478 19.7957C32.8407 18.1811 32.8407 15.819 31.478 14.2043L30.2368 12.7338C29.6575 12.0475 29.3058 11.1983 29.2299 10.3034L29.0678 8.38592C28.8899 6.28049 27.2196 4.61025 25.1142 4.4322L23.1967 4.27005C22.3018 4.19437 21.4525 3.84257 20.7662 3.26332L19.2957 2.02214Z"
              stroke="#FF6500"
            />
          </svg>
          <div
            className={`absolute bottom-[50%] right-[50%] translate-x-[50%] translate-y-[50%] text-[14px] ${
              mission["create_card"] ? "text-white" : "text-black"
            }`}
          >
            {mission["create_card"] ? "✓" : "1"}
          </div>
        </div>
        {isOpen_ && <div>Create card</div>}
      </div>
      <div
        className={`flex flex-row gap-2 text-[14px] font-medium ${
          mission["share_card"] ? "text-primary" : "text-black"
        } items-center`}
      >
        <div className="flex flex-col w-fit relative px-3">
          <svg
            width="33"
            height="34"
            viewBox="0 0 33 34"
            xmlns="http://www.w3.org/2000/svg"
            className={`${
              mission["share_card"] ? "fill-primary" : "fill-transparent"
            }`}
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.2957 2.02214C17.6811 0.659285 15.319 0.659287 13.7043 2.02214L12.2338 3.26332C11.5475 3.84257 10.6983 4.19437 9.80337 4.27005L7.88592 4.4322C5.78049 4.61025 4.11025 6.28049 3.9322 8.38592L3.77005 10.3034C3.69437 11.1983 3.34257 12.0475 2.76332 12.7338L1.52214 14.2043C0.159285 15.819 0.159287 18.1811 1.52214 19.7957L2.76332 21.2662C3.34257 21.9525 3.69437 22.8018 3.77005 23.6967L3.9322 25.6142C4.11025 27.7196 5.78049 29.3899 7.88592 29.5678L9.80337 29.7299C10.6983 29.8058 11.5475 30.1575 12.2338 30.7368L13.7043 31.978C15.319 33.3407 17.6811 33.3407 19.2957 31.978L20.7662 30.7368C21.4525 30.1575 22.3018 29.8058 23.1967 29.7299L25.1142 29.5678C27.2196 29.3899 28.8899 27.7196 29.0678 25.6142L29.2299 23.6967C29.3058 22.8018 29.6575 21.9525 30.2368 21.2662L31.478 19.7957C32.8407 18.1811 32.8407 15.819 31.478 14.2043L30.2368 12.7338C29.6575 12.0475 29.3058 11.1983 29.2299 10.3034L29.0678 8.38592C28.8899 6.28049 27.2196 4.61025 25.1142 4.4322L23.1967 4.27005C22.3018 4.19437 21.4525 3.84257 20.7662 3.26332L19.2957 2.02214Z"
              stroke="#FF6500"
            />
          </svg>
          <div
            className={`absolute bottom-[50%] right-[50%] translate-x-[50%] translate-y-[50%] text-[14px] ${
              mission["share_card"] ? "text-white" : "text-black"
            }`}
          >
            {mission["share_card"] ? "✓" : "2"}
          </div>
        </div>
        {isOpen_ && <div>Share card</div>}
      </div>
    </div>
  );
};

export default Missions;
